import React, { useEffect, useState } from 'react';
import HedinIcon from '@hedinbil/hedin-ui/dist/icons/components/HedinIcon';
import {
  getFilterTypeName,
  getNestedPageKey,
  getPageType,
  getParentItemValue,
  getRangeStepValue,
  getRangeUnit,
} from './utils';
import propTypes from 'prop-types';
import RangeSlider from '@hedinbil/hedin-ui/dist/shop/components/Range/Range';
import withDefault from '@hedinbil/hedin-ui/dist/utils/withDefault';
import {
  UPDATE_FILTER_CHOICES,
  UPDATE_FILTER_CHOICES_RANGE,
  GET_RANGE_FILTERS_MIN_MAX_VALUES,
} from '../../../../Feature/hedin-filters/actions/types';
import { debounce } from '@hedinbil/hedin-ui/dist/utils/debounce';
import { getTranslation } from '../../utils/getTranslation';

const FilterPage = (props) => {
  const {
    onClose,
    onBack,
    onNestedPage,
    hasNestedPage,
    isNested,
    facet,
    setNestedPageTransitionBack,
    nestedPageTransitionBack,
    animationInterval,
    canHaveNestedPage,
    title,
    filterType,
    nestedPageIndex,
    setHasChanged,
    updateDynamicItems,
  } = props;
  const [customClass, setCustomClass] = useState('');

  useEffect(() => {
    if (nestedPageTransitionBack && !isNested) {
      setCustomClass('hb-filter-page-nested-parent-exit');
    } else {
      if (customClass === 'hb-filter-page-nested-parent-exit') {
        setCustomClass('');
      }
    }
  }, [nestedPageTransitionBack]);

  const onBackFilterPage = () => {
    if (isNested) {
      setCustomClass('hb-filter-page-nested-exit');
      setNestedPageTransitionBack(true);
    } else {
      setCustomClass('hb-filter-page-exit');
    }
    setTimeout(() => {
      if (isNested) {
        setCustomClass('hb-filter-page-nested-exited');
        onBack();
        setTimeout(() => {
          setNestedPageTransitionBack(false);
        }, animationInterval / 2);
      } else {
        onBack();
      }
    }, animationInterval);
  };

  const onCloseFilterPage = () => {
    setCustomClass('hb-filter-page-exit');
    setTimeout(() => {
      onBack();
      onClose();
    }, animationInterval);
  };

  const onClickItem = (item, index, isCheckbox) => {
    const filterKey = withDefault(facet.key, Object.keys(facet)[0]);
    if (isCheckbox) {
      props.filterActions(UPDATE_FILTER_CHOICES, item.value, {
        key: filterKey,
        parentValue: getParentItemValue(filterKey, item),
        filterType,
      });
      setHasChanged(true);
      // updateDynamicItems();
    } else {
      if (canHaveNestedPage) {
        if (hasNestedPage) {
          onNestedPage(index);
        } else {
          setCustomClass('hb-filter-page-nested-start');
          setTimeout(() => {
            onNestedPage(index);
            setCustomClass('');
          }, animationInterval);
        }
      }
    }
  };

  const onChangeRange = (e, item) => {
    props.filterActions(UPDATE_FILTER_CHOICES_RANGE, e, {
      key: item.key,
      filterType,
    });
    setHasChanged(true);
  };

  const nestedPageClass = hasNestedPage ? 'hb-filter-page-nested' : '';
  const subNestedPageClass = isNested ? 'hb-filter-page-nested-sub' : '';
  const filterPageType = getPageType(facet.key);
  const debouncedOnClickItem = debounce(onClickItem, 50);

  const nestedPageKey = getNestedPageKey(withDefault(facet.key, Object.keys(facet)[0]));
  const nestedItemsKey = filterType === 'Site' ? 'options' : nestedPageKey;

  return (
    <div
      className={`hb-filter hb-filter-page ${customClass} ${nestedPageClass} ${subNestedPageClass}`}
    >
      <div className="hb-filter__header">
        <p className="hb-filter__header-title">
          {!hasNestedPage && (
            <button
              className="button--clean hb-filter__header-back"
              onClick={() => onBackFilterPage()}
            >
              <HedinIcon iconName="ChevronLeft" />
              <span>Tilbake</span>
            </button>
          )}
          {title}
          {!hasNestedPage && (
            <button
              className="button--clean hb-filter__header-cross"
              onClick={() => onCloseFilterPage()}
            >
              <HedinIcon iconName="Cross" />
            </button>
          )}
        </p>
      </div>
      <div className="hb-filter__content">
        {filterPageType === 'checkboxes' && (
          <>
            {(facet[nestedItemsKey] || []).map((item, index) => (
              <div
                className={
                  'hb-filter__item' + (!isNested && nestedPageIndex === index ? ' active' : '')
                }
                key={index}
              >
                <div
                  className="form-group form-check-group mb-0"
                  onClick={() => debouncedOnClickItem(item, index, true)}
                >
                  <label htmlFor={facet?.key + '_' + index} className="form-check-label mb-0">
                    <input
                      type="checkbox"
                      className="form-check mt-0"
                      id={facet?.key + '_' + index}
                      readOnly={true}
                      checked={item.chosen}
                    />
                    {nestedPageKey === 'carModels' && facet?.label && facet?.brandId !== ''
                      ? facet?.label + ' '
                      : ''}
                    {getTranslation(item?.label)}
                    {item?.activeFilters && item?.activeFilters > 0 ? (
                      <div className="button--filter-count text-center color-white">
                        <span>{item?.activeFilters}</span>
                      </div>
                    ) : null}
                  </label>
                </div>
                {canHaveNestedPage && (
                  <div
                    className="hb-filter__item-icon-wrapper"
                    onClick={() => debouncedOnClickItem(item, index, false)}
                  >
                    <HedinIcon iconName="ChevronRight" className="hb-filter__item-icon" />
                  </div>
                )}
              </div>
            ))}
          </>
        )}
        {filterPageType === 'range' && (
          <div className="hb-filter__section">
            <RangeSlider
              min={props.filterActions(GET_RANGE_FILTERS_MIN_MAX_VALUES, facet.key).rangeMin}
              minValue={facet.chosenMinValue}
              maxValue={facet.chosenMaxValue}
              max={props.filterActions(GET_RANGE_FILTERS_MIN_MAX_VALUES, facet.key).rangeMax}
              step={getRangeStepValue(facet.key)}
              onChange={(e) => onChangeRange(e, facet)}
              unit={getRangeUnit(facet.key)}
            />
          </div>
        )}
      </div>
      <div className="hb-filter__footer">
        {!hasNestedPage && (
          <>
            <button
              className="button button__primary hb-filter__footer-action-btn"
              onClick={() => props.onShowItems(onCloseFilterPage)}
            >
              SE {getFilterTypeName(filterType)}
            </button>
            <button
              className="button button--clean hb-filter__footer-clear-btn"
              onClick={() => props.onClearFilter()}
            >
              <HedinIcon iconName="TrashCan" className="hb-filter__footer-clear-btn-icon" />
              <span>FJERN</span>
            </button>
          </>
        )}
      </div>
    </div>
  );
};

FilterPage.propTypes = {
  text: propTypes.string,
  className: propTypes.string,
  onClick: propTypes.func,
};

export default FilterPage;
